import React from 'react';
import { useTranslation } from 'react-i18next';
import routes from '../../../router/routes';
import useQueryString from '../../../hooks/useQueryString';
import DictionaryList from '../../../containers/shared/DictionaryList';
import { useGetPriceCategoriesQuery } from '../../../store/apis/dictionaries/price-categories';

const List = () => {
  const [t] = useTranslation();
  const { page = 1, pageSize = 20 } = useQueryString();
  const { data, isLoading, isFetching } = useGetPriceCategoriesQuery({ page, pageSize });

  return (
    <DictionaryList
      title={t('Категории цен')}
      data={data?.results}
      dataCount={data?.count}
      loading={isLoading || isFetching}
      detailRoute={routes.priceCategories}
    />
  );
};

export default List;
